import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/authentication/user.store'
import { useContentAccessStore } from '@/content_access/content_access.store.ts'
import { actionPermissions, ACTION_TYPES } from '@/util/access_visibility'
import { dispatchCopyEventFrom } from '@/util/copypaste_helpers'

/**
 * Whether a copy button may copy for this viewer, judged as Vue 2's CopyButton did:
 * signed-out, expired and over-quota viewers are blocked.
 */
export function useCopyButtonPermission() {
  const { authInfo } = storeToRefs(useUserStore())
  const { contentAccessStatusForPermissions } = storeToRefs(useContentAccessStore())

  const isCopyBlocked = computed(
    () => actionPermissions(ACTION_TYPES.COPY, '', {}, authInfo.value, contentAccessStatusForPermissions.value).block
  )

  /**
   * Vue 2's blocked CopyButton copied nothing but still raised a copy event from the button,
   * so an enclosing CopyTrackWrapper reported the attempt; this keeps that event.
   */
  function reportBlockedCopy(event: MouseEvent) {
    dispatchCopyEventFrom(event.currentTarget, true)
  }

  return { isCopyBlocked, reportBlockedCopy }
}
